export default __webpack_public_path__ + "static/media/darthVader.6dd10398.jpg";